import React, { useEffect } from "react"
import { isMobile, isBrowser } from "react-device-detect"
import "./reset.css"
import { ThemeProvider } from "styled-components"
import { theme } from "UI/theme"
import DesktopLayout from "../desktop/_layout/layout"
import MobileLayout from "components/mobile/_layout"
import Modal from "src/components/_shared/modal/modal"
import { useSelector, useDispatch } from "react-redux"
import actions from "src/store/actions"

const Layout = ({ path, children, location }) => {
  const dispatch = useDispatch()
  const closeModals = useSelector(state => state.closeModals)

  useEffect(() => {
    if (closeModals) dispatch({ type: actions.CLOSE_MODALS, payload: false })
  }, [closeModals])

  if (typeof window !== "undefined") {
    return (
      <ThemeProvider theme={theme}>
        <Modal />
        {isMobile && (
          <MobileLayout path={path} location={location}>
            {children}
          </MobileLayout>
        )}
        {isBrowser && (
          <DesktopLayout path={path} location={location}>
            {children}
          </DesktopLayout>
        )}
      </ThemeProvider>
    )
  }
  return <>{children}</>
}

export default Layout
